import update from 'immutability-helper'
import * as PostActionTypes from '../../../constants/contents/PostActionTypes';

const initialState = {
  items: [],
  totalCount: null
};

const itemUpdate = (items, id, values) => items.map(item => {
  if (item.id === id) {
    item = Object.assign({}, item, values)
  }
  return item
})

const updatedItems = (state, id, values) => Object.assign({}, state, {
  items: itemUpdate(state.items, id, values)
})

const selectedItems = (items, id, select) => items.map(item => {
  if (item.id === id) {
    item = Object.assign({}, item, { selected: select })
  }
  return item
});

export default (state = initialState, action) => {
  switch (action.type) {
    case PostActionTypes.CLEAR_ITEMS:
      return {
        items: [],
        totalCount: null,
      }
    case PostActionTypes.RECEIVE_ITEMS:
      return {
        items: action.items,
        totalCount: action.totalCount
      }
    case PostActionTypes.SELECT_ITEM:
      return update(state, {
        items: {
          [state.items.findIndex(item => item.id === action.id)]: {
            selected: {
              $set: true
            }
          }
        }
      })

    case PostActionTypes.DESELECT_ITEM:
      return update(state, {
        items: {
          [state.items.findIndex(item => item.id === action.id)]: {
            selected: {
              $set: false
            }
          }
        }
      })

    case PostActionTypes.SELECT_ALL_ITEMS:
      return update(state, {
        items: {
          $apply: items => items.map(item => {
            if (item.editable) {
              return update(item, {
                selected: {
                  $set: true
                }
              })
            } else {
              return item
            }
          })
        }
      })

    case PostActionTypes.DESELECT_ALL_ITEMS:
      return update(state, {
        items: {
          $apply: items => items.map(item => update(item, {
            selected: {
              $set: false
            }
          }))
        }
      })

    case PostActionTypes.UPDATE_ITEM:
      return updatedItems(state, action.item.id, action.item)

    case PostActionTypes.UPDATE_SELECTED_ITEMS:
      return Object.assign({}, state, {
        items: state.items.map(item => {
          if (item.selected) {
            item = Object.assign({}, item, action.values)
          }
          return item
        })
      })

  }
  return state
}
